import { useLive } from "../lib/db";

/** Points earned per 1,000 MMK for this store — 0 while the program is paused/unconfigured. */
export function useLoyaltyEarnRate(storeId: string): number {
  const { data } = useLive("loyalty_configs", "SELECT * FROM loyalty_configs WHERE store_id = $1", [storeId]);
  const config = data[0] ?? null;
  if (!config || !config.is_active) return 0;
  return Number(config.earn_rate) || 0;
}

/** Points that take 1,000 off a bill at this store; 0 while paying with points is off or the program is paused. */
export function useRedeemRate(storeId: string): number {
  const { data } = useLive("loyalty_configs", "SELECT * FROM loyalty_configs WHERE store_id = $1", [storeId]);
  return data[0]?.is_active ? Number(data[0].redeem_rate) || 0 : 0;
}

/** Whether a sale with a discount still earns points at this store. */
export function useEarnOnDiscounted(storeId: string): boolean {
  const { data } = useLive("loyalty_configs", "SELECT * FROM loyalty_configs WHERE store_id = $1", [storeId]);
  return data[0]?.earn_on_discounted ?? true;
}
